import React, { createContext, useContext, useEffect, useState } from "react";

type ViewportContextType = { isMobile: boolean };

const ViewportContext = createContext<ViewportContextType | undefined>(
  undefined
);

export function ViewportProvider({ children }: { children: React.ReactNode }) {
  const [isMobile, setIsMobile] = useState(true);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    // Deliberate: flip the hydration guard on mount so SSR renders the
    // isMobile=true default and the client reconciles to the real width
    // without a mismatch. Not a cascading-render smell.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setMounted(true);
    let timer: ReturnType<typeof setTimeout>;
    const onResize = () => {
      clearTimeout(timer);
      timer = setTimeout(check, 150);
    };
    window.addEventListener("resize", onResize);
    return () => {
      clearTimeout(timer);
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <ViewportContext.Provider value={{ isMobile: mounted ? isMobile : true }}>
      {children}
    </ViewportContext.Provider>
  );
}

export function useViewport() {
  const context = useContext(ViewportContext);
  if (!context) {
    throw new Error("useViewport must be used within ViewportProvider");
  }
  return context;
}
